// extracted by mini-css-extract-plugin
export default {"container":"admin-layout_container__ulsIM","mainContent":"admin-layout_mainContent__zP1uf"};